import RequestTurnForm from "./requestTurn";
import { Modal } from "../../../components/others/Modal/index";

type TProps = {
  toggleModal: boolean;
  data?: {};
  urlTittle: string;
  refreshFunction?: Function;
  patientType: string;
  isApplicant?: boolean;
  onClose?: Function;
};

const RequestTurn = ({ toggleModal, urlTittle, refreshFunction, patientType, isApplicant, onClose }: TProps) => {
  const styles = "text-2xl text-red-500 font-bold";
  return (
    <>
      <Modal
        show={toggleModal}
        modalTitle={"Nueva solicitud de Turno"}
        titleStyle={styles}
        urlTittle={urlTittle}
        onClose={() => onClose?.()}
      >
        <RequestTurnForm urlTittle={urlTittle} refreshFunction={refreshFunction} patientType={patientType} isApplicant={isApplicant} />
      </Modal>
    </>
  );
};

export default RequestTurn;
